/* CKS crawlability shim - 2026-07-29 - PREVIEW BUILD
 *
 * Why this exists:
 *   Boost AI Search & Discovery renders the collection product grid client-side,
 *   so the HTML Shopify serves contains ZERO <a href="/products/..."> anchors.
 *   Re-enabling the theme's own Liquid product_grid block puts real, crawlable
 *   anchors back into the server response - but leaves two visible grids.
 *
 * What this does (progressive enhancement):
 *   1. Hides the theme grid immediately via a class on <html> (no flash of two grids).
 *   2. Waits for Boost to signal readiness - Boost's own JS adds the class
 *      'boost-sd__filter-product-list--ready' to its container.
 *   3. Once ready, REMOVES the theme grid + its pagination, leaving Boost's grid only.
 *
 * Fail-visible by design:
 *   If Boost is slow, broken, or absent, the theme grid is REVEALED instead of
 *   staying hidden - the page never ends up with no products.
 */
(function () {
  var PENDING = 'cks-boost-pending';
  var BOOST = '.boost-sd__filter-product-list';
  var READY = 'boost-sd__filter-product-list--ready';
  var GRID_ID = 'collection';
  var PAGER = 'nav.n6pg';

  var REVEAL_AFTER = 8000;   // Boost too slow -> show the theme grid rather than nothing
  var GIVE_UP_AFTER = 30000; // stop polling entirely

  var root = document.documentElement;
  root.classList.add(PENDING);

  var start = Date.now();
  var stripped = false;
  var revealed = false;
  var timer = null;

  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  function unhide() {
    if (revealed) return;
    revealed = true;
    root.classList.remove(PENDING);
  }

  function strip() {
    if (stripped) return;
    stripped = true;
    var grid = document.getElementById(GRID_ID);
    if (grid) {
      var next = grid.nextElementSibling;
      if (next && next.matches && next.matches(PAGER) && next.parentNode) {
        next.parentNode.removeChild(next);
      }
      if (grid.parentNode) { grid.parentNode.removeChild(grid); }
    }
    unhide();
    stop();
  }

  function boostReady() {
    var el = document.querySelector(BOOST);
    if (!el) { return false; }
    if (!el.classList.contains(READY)) { return false; }
    return !!el.querySelector('a[href*="/products/"]');
  }

  function tick() {
    var waited = Date.now() - start;

    // No theme grid on this page -> nothing to de-duplicate.
    if (!document.getElementById(GRID_ID)) { unhide(); stop(); return; }

    // Boost not present at all -> the theme grid is the only grid, keep it.
    if (!document.querySelector(BOOST)) {
      if (document.readyState === 'complete') { unhide(); stop(); }
      return;
    }

    if (boostReady()) { strip(); return; }
    if (waited > REVEAL_AFTER) { unhide(); }
    if (waited > GIVE_UP_AFTER) { stop(); }
  }

  function begin() {
    tick();
    if (!stripped && timer === null) { timer = setInterval(tick, 120); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', begin);
  } else {
    begin();
  }
})();